import BindingContext, { createPath } from "@odata/BindingContext";
import { EntitySetName, IPrSubmissionEntity, PrSubmissionEntity } from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode } from "@odata/GeneratedEnums";
import { OData } from "@odata/OData";
import { IDefinition } from "@pages/PageUtils";
import { isDefined } from "@utils/general";

export function getMpsvCodeFromSubType(subType: PrSubmissionSubtypeCode): string {
    switch (subType) {
        case PrSubmissionSubtypeCode.RegZecStart:
            return "A1";
        case PrSubmissionSubtypeCode.RegZecTermination:
            return "A2";
        case PrSubmissionSubtypeCode.RegZecChange:
            return "A3";
        case PrSubmissionSubtypeCode.RegZecCorrection:
            return "A4";
        case PrSubmissionSubtypeCode.RegZecCzechOriginStart:
            return "A6";
        case PrSubmissionSubtypeCode.RegZecCzechOriginEnd:
            return "A7";
        case PrSubmissionSubtypeCode.RegZecCancellation:
            return "A8";
        default:
            return null;
    }
}

export async function getRegZecSubtype(oData: OData, bc: BindingContext): Promise<PrSubmissionSubtypeCode> {
    let submissionSubType: PrSubmissionSubtypeCode = null;
    if (bc.isNew()) {
        // new entity is not supported for RegZec, should be called via SubmissionWizard with specific subtype in param
        throw new Error("Cannot create new RegZec submission directly, use SubmissionWizard instead.");
    } else {
        try {
            // check from data is current doc is Employee type
            const entitySetName = bc.getEntitySet().getName() as EntitySetName;
            const query = oData.getEntitySetWrapper(entitySetName)
                .query(bc.getKey())
                .select(PrSubmissionEntity.Id, PrSubmissionEntity.SubmissionSubtypeCode);

            const result = await query.fetchData<IPrSubmissionEntity>();
            submissionSubType = result.value.SubmissionSubtypeCode;
        } catch(e) {
            // fall silently
            submissionSubType = PrSubmissionSubtypeCode.RegZecStart;
        }
    }

    return submissionSubType;
}

export function cleanUpUnavailableFieldsFromGroups(d: IDefinition): void {
    const { fieldDefinition } = d.form;

    d.form.groups = d.form.groups?.filter(group => {
        group.rows = group.rows.map(row => {
            row = row.filter(field => {
                const used = fieldDefinition[field.id];
                return isDefined(used);
            });

            return row?.length ? row : null;
        }).filter(isDefined);

        if (group.lineItems) {
            group.lineItems.columns = group.lineItems?.columns?.filter(field => {
                const fullPath = createPath(group.lineItems.collection, field.id);
                const used = fieldDefinition[fullPath];
                return isDefined(used);
            });
            if (!group.lineItems.columns?.length) {
                delete group.lineItems;
            }
        }

        // filter out if group wo fields
        return group.rows?.length > 0 || group.lineItems?.columns?.length > 0;
    });

}